import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'bootstrap/dist/css/bootstrap.min.css'
import "bootstrap"
import 'element-plus/dist/index.css'
import naive from 'naive-ui'

const app = createApp(App);
app.use(router);
app.use(VueAxios, axios);
app.use(naive);
app.mount('#app');